import { Link } from "react-router-dom";
import DesktopNav from "../UI elements/DesktopNav";
import { useState } from "react";
import PlanCard from "../UI elements/PlanCard";
import AppStoreButtons from "./StoreButtons";

const Credits = (props) => {
  const [ChangesMade] = useState(true);

  return (
    <div className="profile-wrapper">
      <DesktopNav
        SwitchTab={(IsCreditsTab) => props.SwitchTab(IsCreditsTab)}
        CreditsTabIsSelected={props.CreditsTabIsSelected}
      />
      <div className="form-wrapper">
        <div className="form-head">
          <h1>Credit overview</h1>
          <section className="head-actions">
            <span
              className={
                ChangesMade
                  ? "action-btn cancel cancel-purple"
                  : "action-btn cancel cancel-purple disabled"
              }
            >
              <Link to="/Home">Cancel</Link>
            </span>
          </section>
        </div>
        <main className="form-content">
          <p className="credint-balance">
            Available Credits: {props.ProfileInfo.userCredit.balance}
          </p>
          <p className="credint-balance">
            Used Credits: {props.ProfileInfo.userCredit.creditSpent}
          </p>
        </main>
        <p className="info-text">
          Download the WeddinglyAi app from the Apple App Store or Google Play
          to unlock more credits and features. Log in with the same
          account,choose a plan, and complete your purchase. After purchase,
          sign out and back in here to refresh your credits.
        </p>
        <p className="sub-info-text">
          You can access your benefits on{" "}
          <span
            style={{
              textTransform: "uppercase",
            }}
          >
            all devices
          </span>{" "}
          using the same login credentials!
        </p>
        <AppStoreButtons />
        <section className="plans-wrapper">
          <PlanCard
            Title={"Silver Plan"}
            Price={"$4.99 / month"}
            Content={[
              "500 Credits for Image Generation",
              [
                "1 Million Tokens for WeddinglyAi agent",
                "Good for light wedding planning & questions",
              ],
              "Access to all WeddinglyAi AI Models",
              "AI Image Editing (prompt-based)",
              "Photo Editor (crop, rotate, filters)",
              "Unlimited Image Upload",
              "Unlimited Projects",
            ]}
          />
          <PlanCard
            Title={"Gold Plan"}
            Price={"$9.99 / month"}
            Content={[
              "1,000 Credits for Image Generation",
              [
                "2 Million Tokens for WeddinglyAi agent",
                "Detailed wedding planning, ideas & checklists",
              ],
              "No Watermarks",
              "Access to all WeddinglyAi AI Models",
              "AI Image Editing (prompt-based)",
              "Photo Editor (crop, rotate, filters)",
              "Unlimited Image Upload",
              "Unlimited Projects",
            ]}
            IsPopular
          />
          <PlanCard
            Title={"Platinum Plan"}
            Price={"$14.99 / month"}
            Content={[
              "2,000 Credits for Image Generation",
              [
                "5 Million Tokens for WeddinglyAi agent",
                "Best for heavy wedding planning",
              ],
              "No Watermarks",
              "Access to all WeddinglyAi AI Models",
              "AI Image Editing (prompt-based)",
              "Photo Editor (crop, rotate, filters)",
              "Unlimited Image Upload",
              "Unlimited Projects",
            ]}
          />
        </section>
      </div>
    </div>
  );
};

export default Credits;
